import useSWRImmutable from 'swr/immutable'

import { PUBLIC_THERAPISTS_PAGE_SLUG } from '../constants/locale.constants'
import { fetchProcessedTherapists } from '../utilities/apiUtils'
import { USE_THERAPISTS_SWR_KEY } from './useTherapists'

const useLinkForTherapist = (therapistId, isPublic) => {
  const { data: therapists } = useSWRImmutable(USE_THERAPISTS_SWR_KEY, fetchProcessedTherapists)

  const therapist = therapists?.find((therapist) => therapist.therapistId === therapistId)

  if (!therapistId || !therapist) return null

  const linkToTherapistProfile = therapistId
    ? isPublic
      ? `/${PUBLIC_THERAPISTS_PAGE_SLUG}/${therapist?.slug}`
      : `/client/${therapistId}/profile`
    : ''
  return linkToTherapistProfile
}

export default useLinkForTherapist
